import styled from 'styled-components'

export const ImgContainer = styled.div`
  display: flex;
  justify-content: start;
`

export const Img = styled.img`
  height: 60px;
  max-width: 250px;
`
